<template>
  <v-container>
    <v-form ref="form" v-model="valid" lazy-validation>
      <h2 class="mt-8 text-xl">Encounter details</h2>
      <div class="mt-8 grid grid-cols-5 grid-flow-col w-full">
        <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
          <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
            <p><label for="name" class="text-gray-800 px-1">Encounter ID</label></p>
          </div>
          <p>
            <input id="name" autocomplete="false" v-model="encounter.systemId" tabindex="0" type="text" class="py-1 px-1 text-gray-900 outline-none block h-full w-full">
          </p>
        </div>
        <div class="space-y-1 px-2">
          <label class="-mt-4 absolute block text-sm uppercase font-medium text-gray-700">
            Provider
          </label>
          <dropdown v-model="encounter.serviceProvider.display" :options="serviceProviders"></dropdown>
        </div>
        <div class="space-y-1 px-2">
          <label class="-mt-4 absolute block text-sm uppercase font-medium text-gray-700">
            Encounter Type
          </label>
          <dropdown v-model="encounter.basedOn" :options="['DR Screening', 'Specialist consult']"></dropdown>
        </div>
        <!-- <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
          <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
            <p>
              <label for="name" class="text-gray-800 px-1">Encounter type</label>
            </p>
          </div>
          <select v-model="encounter.basedOn">
            <option>DR Screening</option>
            <option>Specialist consult</option>
          </select>
        </div> -->
        <div class="border focus-within:border-blue-500 focus-within:text-blue-500 transition-all duration-500 relative rounded p-1">
          <div class="-mt-4 absolute tracking-wider px-1 uppercase text-xs">
            <p>
              <label for="name" class="text-gray-800 px-1">Encounter Date</label>
            </p>
          </div>
          <p>
            <input id="name" v-model="formattedDate" autocomplete="false" tabindex="0" type="text" class="py-1 px-1 text-gray-900 outline-none block h-full w-full">
          </p>
        </div>
      </div>
      <!-- <v-layout row v-for="(id, index) in encounter.identifier" :key="index">
        <v-flex xs3 sm2 md2>
          <v-text-field
            v-model="id.value"
            label="Encounter ID"
          ></v-text-field>
        </v-flex>
        <v-flex xs4 sm3 md3>
          <v-select
            v-model="id.assigner"
            :items="serviceProviders"
            item-text="display"
            item-value="display"
            :rules="[v => !!v || 'Item is required']"
            label="Provider"
            return-object
            required
          ></v-select>
        </v-flex>
        <v-flex xs4 sm3 md3>
          <v-select
            v-model="encounter.basedOn"
            :items="planDefinitions"
            :rules="[v => !!v || 'Item is required']"
            label="Encounter type"
            required
          ></v-select>
        </v-flex>
        <v-flex xs2 sm2 md2>
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="formattedDate"
                clearable
                label="Date of encounter"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="encounter.period.start"
              @change="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
      </v-layout> -->
      <v-layout row v-if="!saved">
        <v-btn
        :disabled="!valid"
        class="mr-4"
        @click="createEncounter">
          Create encounter
        </v-btn>
      </v-layout>
      <div v-if="saved" class="pt-2 md:pt-1 pb-1 px-1 mt-4 h-auto w-full">
        <h3 class="text-lg">Dilation</h3>
        <div class="w-full flex space-x-3">
          <div class="flex-grow-0 flex items-center">
            <label class="self-center text-center pl-4 py-2 m-2">Dilation administered?</label>
            <toggle-switch class="flex-none" v-model="treatments.dilation.administered">
            </toggle-switch>
          </div>
            <!-- <v-switch
              v-model="treatments.dilation.administered"
              label="Dilation administered?"
            ></v-switch> -->
          <!-- <v-flex sm5 md5 v-if="treatments.dilation.administered"> -->
          <div v-if="treatments.dilation.administered" class="space-y-1 px-1">
            <label class="-mt-4 absolute block text-sm uppercase font-medium text-gray-700">
              Mydriasis agent
            </label>
            <dropdown v-model="treatments.dilation.agent" :options="mydriasisOptions"></dropdown>
          </div>
        </div>
        <h3 class="text-lg">Presenting Vision</h3>
        <v-subheader>Visual acuity - best corrected</v-subheader>
        <div v-if="results.observations.visualAcuity">
          <v-layout row>
            <v-flex sm5 md5 offset-xs1>
              <span class="text-lg">OD: {{results.observations.visualAcuity.OD}}</span>
            </v-flex>
            <v-flex sm2 md2 offset-xs1>
              <span class="text-lg">OS: {{results.observations.visualAcuity.OD}}</span>
            </v-flex>
          </v-layout>
        </div>
        <div v-else class="template" v-on:click="launchDialog('visualAcuity')">
          Click here to add visual acuity
        </div>
        <h3>Retinal and Anterior Images</h3>
        <v-layout row>
          <v-flex sm5 md5>
            <div v-for="image in odImages" :key="image"></div>
            <v-btn @click="uploaderVisible=true">Upload OD images</v-btn>
            <!-- <v-file-input label="Upload OD images" filled prepend-icon="mdi-camera"
            ></v-file-input> -->
          </v-flex>
          <v-flex sm5 md5>
            <!-- <v-file-input label="Upload OS images" filled prepend-icon="mdi-camera"
            ></v-file-input> -->
            <v-btn @click="uploaderVisible=true">Upload OS images</v-btn>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="saved && encounter.basedOn === 'Specialist consult'" class="pt-2 md:pt-1 pb-1 px-1 mt-4 h-auto w-full">
        <h3 class="text-lg">Diagnoses</h3>
        <div class="w-full flex space-x-3">
          <div class="flex-grow-0 flex items-center">
            <label class="self-center text-center pl-4 py-2 m-2">Cataract present/suspect</label>
            <toggle-switch class="flex-none mx-2 pr-2">
            </toggle-switch>
            <v-btn @click="locsVisible=true">Grade LOCS</v-btn>
          </div>
        </div>
      </div>
      <cataract-opacity v-if="locsVisible && encounter.basedOn === 'Specialist consult'"></cataract-opacity>
    <!-- <v-subheader>Demographics</v-subheader>
    <v-layout row wrap>
      <v-flex xs4 sm3 md3>
        <v-text-field
          v-model="patient.birthDate"
          label="Date of birth"
        ></v-text-field>
      </v-flex>
    </v-layout>
      <v-checkbox
        v-model="checkbox"
        :rules="[v => !!v || 'You must agree to continue!']"
        label="Do you agree?"
        required
      ></v-checkbox> -->
    <v-layout row v-if="saved" class="mt-20">
      <v-btn
      :disabled="!valid"
      class="mr-4">
        Save
      </v-btn>
      <v-btn
      v-if="encounter.basedOn === 'DR Screening'"
      :disabled="!valid"
      class="mr-4">
        Submit for screening
      </v-btn>
      <v-btn
        class="mr-4">
        Reset
      </v-btn>
    </v-layout>
  </v-form>
  <!-- modals -->
  <div v-if="modal" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- background overlay -->
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <visual-acuity class="w-full" @recordResult="recordVA"></visual-acuity>
      </div>
    </div>
  </div>
  <!-- <v-dialog
      v-model="inputDialog"
      width="600"
    >
    <v-card>
      <div v-if="results.Observation.visualAcuity">
        <v-card-title>Visual Acuity</v-card-title>
        <div class="va-container">
          <div class="va-sliders">
            <v-slider
              v-model="results.Observation.visualAcuity.od"
              :tick-labels="vaLabels"
              :max="5"
              step="1"
              ticks="always"
              tick-size="6"
              vertical
            ></v-slider>
            <p>{{calculateVA(od)}}</p>
          </div>
          <div class="va-sliders">
            <v-slider
              v-model="results.Observation.visualAcuity.os"
              :tick-labels="vaLabels"
              :max="5"
              step="1"
              ticks="always"
              tick-size="6"
              vertical
            ></v-slider>
            <p>{{calculateVA(od)}}</p>
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-btn color="pink" flat @click="inputDialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog> -->
  <!-- <v-dialog v-model="uploaderVisible" width="500">
    <div v-if="uploaderVisible">
      <v-card>
        <file-upload></file-upload>
        <v-btn @click="uploaderVisible = false">Close</v-btn>
      </v-card>
    </div>
  </v-dialog> -->
  <v-snackbar v-model="patientSaveSnackbar" :bottom="true" :left="false" :multi-line="false"
    :right="false" :timeout=6000 :top="false" :vertical="true">
    Patient record saved.
    <v-btn color="pink" flat>Close</v-btn>
  </v-snackbar>
</v-container>
</template>

<script>
import apiCall from '../utils/api'
import { DateTime } from 'luxon'
import CataractOpacity from '@/components/CataractOpacity.vue'
import Dropdown from '@/components/Dropdown.vue'
import FileUpload from '@/components/FileUpload.vue'
import ObservationEdit from '@/components/ObservationEdit.vue'
import ToggleSwitch from '@/components/ToggleSwitch.vue'
import VisualAcuity from '@/components/VisualAcuity.vue'

export default {
  data () {
    return {
      assessmentActions: [
        { 'title': 'Comorbidity', 'description': 'Co-morbidities including Charlson Comorbidity Index', 'profile': 'Comorbidity' },
        { 'title': 'BMI', 'description': 'Body Mass Index', 'profile': 'BMI' },
        // {'title': 'Modified Kellgren-Lawrence', 'profile': 'KellgrenLawrence'},
        { 'title': 'HOOS', 'description': 'HOOS Hip Survey','profile': 'Survey' },
        { 'title': 'KOOS', 'description': 'KOOS Knee Survey','profile': 'Survey' },
        { 'title': 'SF-12', 'description': 'Short-form health-related quality of life survey','profile': 'Survey' }
      ],
      dateMenu: false,
      distance: '',
      encounter: {},
      inputDialog: false,
      jointObservations: [{ bodyPart: '', painArea: '', index: true }],
      joints: ['Right knee', 'Left knee', 'Right hip', 'Left hip', 'Spine'],
      kellgrenLawrenceGrades: [
        { grade: 0, desc: '0 - no radiographic features of OA are present' },
        { grade: 1, desc: '1 - doubtful joint space narrowing (JSN) and possible osteophytic lipping' },
        { grade: 2, desc: '2 - definite osteophytes and possible JSN on anteroposterior weight-bearing radiograph' },
        { grade: 3, desc: '3 - multiple osteophytes, definite JSN, sclerosis, possible bony deformity' },
        { grade: 4, desc: '4 - large osteophytes, marked JSN, severe sclerosis and definite bony deformity' }
      ],
      locsVisible: false,
      modal: false,
      mydriasisOptions: ['2.5% phenylephrine and 0.5% tropicamide', '2.5% phenylephrine and 1% tropicamide'],
      painAreas: ['Anterior knee', 'Medial knee', 'Lateral knee', 'Posterior knee', 'Lower leg', 'Lumbar', 'Groin', 'Lateral hip', 'Posterior hip'],
      patientSaveSnackbar: false,
      patient: {},
      plan: {},
      planDefinitions: ['Screening study', 'Screening study follow-up', 'Optometry'],
      results: {
        ClinicalImpression: {},
        observations: {},
        Questionnaire: {},
        ServiceRequest: {}
      },
      results2: {
        charlson: {
          'Myocardial infarction': false,
          'Congestive heart failure': false,
          'Peripheral vascular disease': false,
          'Cerebrovascular disease': false,
          'Dementia': false,
          COPD: false,
          'Connective Tissue Disease': false,
          'Peptic ulcer disease': false,
          'Diabetes with end organ damage': false,
          'Diabetes without end organ damage': false,
          'Chronic Kidney Disease - moderate to severe': false,
          Hemiplegia: false,
          Leukaemia: false,
          Lymphoma: false,
          'Moderate or severe liver disease': false,
          'Any malignancy without metastasis': false,
          'Metastatic solid tumour': false,
          AIDS: false
        },
        hip_kl: '',
        knee_kl: '',
        vaLabels: [
          '6/4.5',
          '6/6',
          '6/7.5',
          '6/9',
          '6/12',
          '6/15',
          '6/21',
          '6/30',
          '<6/60',
          'nlp'
        ],
        xray_knee: { status: '' }
      },
      saved: false,
      selected: [0],
      serviceProviders: this.$store.state.init.org.valueLists.encounterProviders,
      treatments: {
        dilation: { administered: false, agent: '' }
      },
      uploaderVisible: false,
      valid: true,
      walkingDistances: ['Less than 50 metres', '50-100 metres', '100-500 metres', '500-1000 metres', 'Unlimited'],
      xrayStatus: '',
      xrayStatuses: ['ordered', 'sighted']
    }
  },
  computed: {
    formattedDate () {
      return DateTime.fromISO(this.encounter.period.start).toFormat('dd/LL/yyyy')
    },
    kneeOa () {
      return this.jointObservations.find(joint => joint.bodyPart.endsWith('knee'))
    },
    xrayStatusHip () {
      if (this.results.ServiceRequest.xray_hip) {
        return this.results.ServiceRequest.xray_hip.status === 'sighted'
      }
    }
  },
  components: {
    CataractOpacity, Dropdown, FileUpload, ObservationEdit, ToggleSwitch, VisualAcuity
  },
  methods: {
    addJoint () {
      this.jointObservations.push({ bodyPart: '', painArea: '', index: false })
    },
    async createEncounter () {
      // await this.getPlanDefinition()
      this.saved = true
    },
    getInputCoding (coding) {
      // get the clinres coded element
      return coding.find(coding => coding.system === 'clinres')
    },
    async getPlanDefinition () {
      const planDefinition = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/planDefinition/${this.encounter.basedOn}`)
      this.plan = planDefinition.data
      this.plan.action.forEach(action => {
        if (action.output && action.output.profile.coding) {
          const propertyCode = this.getInputCoding(action.output.profile.coding)
          if (propertyCode) {
            // if array
            if (action.output.profile.multipleResultsAllowed) {
              this.results[action.output.type][propertyCode.code] = [];
            } else if (action.output.profile.permittedDataType === 'string') {
              this.results[action.output.type][propertyCode.code] = '';
            }
          }
        }
      })
    },
    // when a selection is made, if the result property doesnt exist, create it
    // onObservationMulti(event, code) {
    //   if (!this.results.Observation[code]) {
    //     this.results.Observation[code] = [event]
    //   }
    // },
    launchDialog (resultCode) {
      if (resultCode === 'visualAcuity') {
        this.results.observations.visualAcuity = { od: {}, os: {} }
      }
      this.modal = true
      console.log(resultCode)
    },
    onObservationSelection (event, code) {
      if (!this.results.observations[code]) {
        this.results.observations[code] = event
      }

      if (this.results.Observation.oa_index_joint && !this.results.Observation.joint_pain_sites) {
        this.results.Observation.joint_pain_sites = [];
      }
    },
    onJointSelected (event) {
      console.log(`adding ${event} to oa_body_site`)
      if (!this.results.Observation.oa_body_site) {
        this.results.Observation.oa_body_site = [event]
      } else {
        this.results.Observation.oa_body_site.push(event)
      }

      if (event.endsWith('knee')) {
        this.results.ServiceRequest.xray_knee = {status: ''}
      } else if (event.endsWith('hip')) {
        this.results.ServiceRequest.xray_hip = {status: ''}
      }
    },
    recordVA (result) {
      this.modal = false
      this.results.observations.visualAcuity = result
    },
    async savePatient () {
      const saveResponse = await this.axios.post(`${process.env.VUE_APP_API_BASEURL}/patient`, this.patient, {})
      console.log(`api response: ${saveResponse.status} - ${saveResponse.data}`)
      this.patientSaveSnackbar = true
    },
    xraySighted(joint){
      if (this.results.ServiceRequest[`xray_${joint}`]){
        return this.results.ServiceRequest[`xray_${joint}`].status === 'sighted'
      } else {
        return false
      }
      
    }
  },
  async created () {
    // populate the patient variable
    const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
    this.patient = results.data
    // if (!isNaN(parseFloat(this.$route.params.patientId))) {
    //   const results = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/patient/${this.$route.params.patientId}`)
    //   this.patient = results.data
    //   this.patient.birthDate = DateTime.fromISO(this.patient.birthDate)
    // } else {
    if (this.$route.params.encounterId === 'new') {
      // get the list of PlanDefinitions from the API
      const plans = await this.axios.get(`${process.env.VUE_APP_API_BASEURL}/planDefinitions`)
      // this.planDefinitions = plans.data
      this.encounter = {
        identifier: { use: 'official', value: '', assigner: 'Alice Springs Clinic' },
        basedOn: '',
        serviceType: '',
        subject: { type: 'Patient', identifier: this.$route.params.patientId },
        type: '',
        reasonCode: '',
        appointment: '',
        period: { start: DateTime.local().toISO(), end: '' },
        serviceProvider: this.$store.state.init.org.defaults.encounterProvider
      }

      // get a new encounter id from the API
      const incrementRequest = await apiCall(`/encounter/id`, 'get', this.encounter)
      if (incrementRequest) {
        this.$set(this.encounter, 'systemId', incrementRequest.data)
      } else console.log('api call failed')
    }
  }
  // }
}
</script>
<style scoped>
  .template {
    height: 60px;
    width: 90%;
    margin: 10px;
    padding: 15px;
    border: 3px dashed #999999;
    text-align: center;
  }
  .va-container {
    height: 230px;
  }
  .va-sliders {
    width: 40%;
    float: left;
  }
</style>
